import React from "react";
import Table from "./table";

const Users = () => (
  <>
    <Table />
  </>
);

export default Users;
